import { render, staticRenderFns } from "./Suc.vue?vue&type=template&id=21fd6e4c&"
import script from "./Suc.vue?vue&type=script&lang=js&"
export * from "./Suc.vue?vue&type=script&lang=js&"
import style0 from "./Suc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports